let url = {
  //Basic: 'http://localhost:8080',
  //test
  Basic: 'https://pdps.nat.gov.tw/PdpsCli',
  //PdpsBackEndService : 'http://localhost:1150',
  PdpsBackEndService : 'https://pdps.nat.gov.tw/PdpsBackEndService',
  //PdpsBackstageApi : 'http://localhost:13350',
  PdpsBackstageApi : 'https://pdps.nat.gov.tw/PDPSBackstageApi',
};

if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
  url = { //本機
    Basic: 'http://localhost:8080',
    //PdpsBackEndService : 'https://pdps-bate.moj.gov.tw/PdpsBackEndService',
    PdpsBackEndService : 'http://localhost:1150',
    PdpsBackstageApi : 'http://localhost:13350',
    //PdpsBackstageApi : 'https://pdps-bate.moj.gov.tw/PDPSBackstageApi',//管理後台
    //Basic: 'https://pdps.nat.gov.tw/PdpsCli',
    //PdpsBackEndService : 'https://pdps.nat.gov.tw/PdpsBackEndService',//申報後台
    //PdpsBackstageApi : 'https://pdps.nat.gov.tw/PDPSBackstageApi',//管理後台
  };
} else if(window.location.host === "pdps-bate.moj.gov.tw") {
  url = { //前置機
    Basic: 'https://pdps-bate.moj.gov.tw/PdpsCli',
    PdpsBackEndService : 'https://pdps-bate.moj.gov.tw/PdpsBackEndService',//申報後台
    PdpsBackstageApi : 'https://pdps-bate.moj.gov.tw/PDPSBackstageApi',//管理後台
  };
} else {
  url = { //正式機
    Basic: 'https://pdps.nat.gov.tw/PdpsCli',
    PdpsBackEndService : 'https://pdps.nat.gov.tw/PdpsBackEndService',//申報後台
    PdpsBackstageApi : 'https://pdps.nat.gov.tw/PDPSBackstageApi',//管理後台
  };
}
export default url
